var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.32143 7.66287L15.4945 1.48977C15.8352 1.14911 15.8352 0.596157 15.4945 0.255496C15.1539 -0.0851653 14.6009 -0.0851653 14.2603 0.255496L8.08716 6.4286L2.0782 0.419639C1.73754 0.0789779 1.18458 0.0789779 0.843923 0.419639C0.503262 0.7603 0.503262 1.31325 0.843923 1.65391L6.85288 7.66287L0.68323 13.8325C0.342569 14.1732 0.342569 14.7261 0.68323 15.0668C1.02389 15.4075 1.57684 15.4075 1.91751 15.0668L8.08716 8.89715L14.4209 15.2309C14.7616 15.5716 15.3146 15.5716 15.6552 15.2309C15.9959 14.8903 15.9959 14.3373 15.6552 13.9967L9.32143 7.66287Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelWhite);
export default __webpack_public_path__ + "static/media/cancel-white.3eecc69d47e1b77ea088db07817ecde8.svg";
export { ForwardRef as ReactComponent };